import { UseMutationOptions } from "@tanstack/react-query";
import {
  CSVApiImportCsvFromFileAsyncRequest,
  ImportCsvFromRecordsAsync200Response,
} from "@rentablo/api/apiv3";
import { useAuthMutation, axiosInstanceV3 } from "@rentablo/api";

// Custom method because the generated client serializes the file as JSON
// (see packages/api/src/apiv3/client/csvapi.ts). Backend expects text/csv.
export const importCsvFromFile = async (
  token: string | undefined,
  params?: CSVApiImportCsvFromFileAsyncRequest
): Promise<ImportCsvFromRecordsAsync200Response> => {
  const file = params?.file as File | undefined;
  const csvFile = file
    ? new File([file], file.name, { type: "text/csv" })
    : undefined;
  const { data } = await axiosInstanceV3.postForm(
    `/csv/import_file_async`,
    {
      file: csvFile,
      depot_id: params?.depotId,
      bank_slug: params?.bankSlug,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const useCsvImportFile = (
  options?: UseMutationOptions<
    ImportCsvFromRecordsAsync200Response,
    AxiosApiError,
    CSVApiImportCsvFromFileAsyncRequest
  >
) => {
  return useAuthMutation(importCsvFromFile, options);
};
